import { parseUserMetadata, useAuth } from '../useAuth';
import {
  useGetSubscriptionTypeQuery,
  UserSubscriptionType,
} from '@doxyme/frontend/services/subscriptions';

/**
 * Determining whether the user is an OG clinic user.
 *
 * @returns {boolean} `true` if the user is an OG clinic user, `false` otherwise
 */
export const useIsOgClinicUser = (): boolean => {
  const { user } = useAuth();
  const metadata = parseUserMetadata(user?.metadata);
  const { data: subscriptionType } = useGetSubscriptionTypeQuery(
    {
      userId: metadata?.legacyUserId ?? '',
      skipInstitutionCheck: false,
    },
    {
      skip: !metadata?.legacyUserId,
    },
  );

  if (!metadata?.legacyUserId) {
    return false;
  }

  return subscriptionType?.subscriptionType === UserSubscriptionType.Clinic;
};
